import getFullUserName from 'utils/getFullUserName';
function shortenEmail(email) {
  if (email.length > 16) {
    return email.substring(0, email.indexOf('@'));
  }
  return email;
}
function getUserDisplayName(profile) {
  if (!(profile !== null && profile !== void 0 && profile.first_name) && !(profile !== null && profile !== void 0 && profile.email)) {
    return null;
  }
  return getFullUserName(profile) || shortenEmail(profile.email);
}
export default getUserDisplayName;